import React from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {RUB_SYMBOL} from 'core/constants';

interface IPriceProgressBarProps {
    percent?: number;
    left?: number;
}

function convertToScale(number = 1): number {
    return Math.round((number - 1) * 0.5253 + 53);
}

export const PriceProgressBar = ({percent, left}: IPriceProgressBarProps) => {
    const minimalPricePercent = percent || 0;
    const showMinimalPriceProgressBar = 100 > minimalPricePercent && 0 <= minimalPricePercent && left;

    if (!showMinimalPriceProgressBar) {
        return null;
    }

    return (
        <div className={style.minimalCartPriceContainer}>
            <div className={style.minimalCartPriceContent}>
                <svg
                    width={'23'}
                    height={'23'}
                    viewBox={'0 0 23 23'}
                    fill={'none'}
                    xmlns={'http://www.w3.org/2000/svg'}
                >
                    <circle cx={'11.5'} cy={'11.5'} r={'9'} stroke={'#ffffff'} strokeWidth={'2.7'}></circle>
                    <circle
                        cx={'11.5'}
                        cy={'11.5'}
                        r={'9'}
                        className={style.progressCircle}
                        stroke={'#19C85F'}
                        strokeWidth={'2.7'}
                        strokeDasharray={`${convertToScale(percent)}px`}
                        strokeDashoffset={`${50}px`}
                        strokeLinecap={'round'}
                        transform={'rotate(-90 11.5 11.5)'}
                    ></circle>
                </svg>
                <Typography variant={'label-14-r'} color={'white100'}>
                    До минимальной суммы заказа {left} {RUB_SYMBOL}
                </Typography>
            </div>
        </div>
    );
};
